import React from 'react'
import { LayoutWrapper } from './styled'

const Layout = ({ children }: any) => {
  return <LayoutWrapper>{children}</LayoutWrapper>
}

export default Layout
